enum LabelPosition {
  Top = 'top',
  Left = 'left',
}

export default LabelPosition;
